import {Component} from 'react';
import PropTypes from 'prop-types';
import {joinNonEmpties} from 'api/reports/util/StringUtils';
import get from 'lodash/get';
import {Grid} from 'semantic-ui-react';

export default class TitleOwners extends Component {
  static propTypes = {
    className: PropTypes.string,
    owners: PropTypes.arrayOf(PropTypes.shape({
      corporateName: PropTypes.string.isRequired,
      otherNames: PropTypes.string.isRequired,
      surname: PropTypes.string.isRequired
    }).isRequired)
  };

  render() {
    const {className, owners} = this.props;
    const classNames = ['title-owners', className].join(' ').trim();

    let ownerStrings = owners.map(owner => {
      return joinNonEmpties([
        get(owner, 'corporateName'),
        get(owner, 'surname'),
        get(owner, 'otherNames'),
      ], ', ') || '';
    });

    let ownerText = joinNonEmpties(ownerStrings, ', ') || '';

    return (
      <div className={classNames}>
        <Grid>
          <Grid.Row>
            <Grid.Column className="left" width={4}>
              <strong>Proprietors</strong>
            </Grid.Column>
            <Grid.Column width={12}>
              {ownerText ? ownerText : '-'}
            </Grid.Column>
          </Grid.Row>
        </Grid>
      </div>
    );
  }
}